import { useFormContext } from "react-hook-form";
import { FormControl, Input, InputLabel } from "@mui/material";
import daLiJePoljeValidno from "../../../../utils/daLiJePoljeValidno";
import { PorukaGreskePolja } from "../../../index";

const Index = ({ nazivOdjeljka, label, disabled }: any) => {
  const { register } = useFormContext();
  return (
    <FormControl fullWidth error={!daLiJePoljeValidno(nazivOdjeljka)}>
      <InputLabel htmlFor={nazivOdjeljka}>
        {label ? label : "*Naziv (Name)"}
      </InputLabel>
      <Input
        aria-describedby="naziv"
        {...register(nazivOdjeljka)}
        disabled={disabled}
      />
      <PorukaGreskePolja nazivPolja={`${nazivOdjeljka}.naziv`} />
    </FormControl>
  );
};

export default Index;
